export default __webpack_public_path__ + "static/real-estate-ea8132b32ecf90ed459d777be1994176.gif";